export const getHost = () => {
	return `${window.location.protocol}//${window.location.hostname}/`;
}